import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import { useAuth } from '../components/auth/AuthContext';
import './HomePage.css';

const PORTAL_SERVICES_URL = '/server/portal_services';

function HomePage() {
  const [quoteIdInput, setQuoteIdInput] = useState('');
  const [unreadCount, setUnreadCount] = useState(0);
  const navigate = useNavigate();
  const { currentUser } = useAuth();

  // Fetch počtu nepřečtených zpráv
  useEffect(() => {
    const fetchUnread = async () => {
      try {
        const response = await fetch(`${PORTAL_SERVICES_URL}/chat/conversations`, {
          credentials: 'include'
        });
        if (response.ok) {
          const data = await response.json();
          setUnreadCount(data.totalUnread || 0);
        }
      } catch (error) {
        console.error('Error fetching unread count:', error);
      }
    };
    fetchUnread();
    const interval = setInterval(fetchUnread, 30000);
    return () => clearInterval(interval);
  }, []);

  const handleOpenQuote = (e) => {
    e.preventDefault();
    if (quoteIdInput.trim()) {
      navigate(`/quote/${quoteIdInput.trim()}`);
    } else {
      toast.warn('Prosím, zadejte ID nabídky.');
    }
  };

  const handleSignOut = () => {
    const signOutRedirect = window.location.origin + '/app/';
    if (window.catalyst && window.catalyst.auth) {
      window.catalyst.auth.signOut(signOutRedirect);
    } else {
      window.location.href = signOutRedirect;
    }
  };

  return (
    <div className="homepage-container">
      <header className="homepage-header">
        <h1>QuoteMachine</h1>
        <div className="header-right">
          <span className="user-name">{currentUser?.first_name || 'User'}</span>
          <button onClick={handleSignOut} className="btn-signout">
            Odhlásit se
          </button>
        </div>
      </header>

      <div className="homepage-content">
        {/* Quote Editor Card */}
        <section className="dashboard-card">
          <h2>📄 Quote Editor</h2>
          <p>Otevřete nabídku pro úpravu zadáním jejího CRM ID.</p>
          <form onSubmit={handleOpenQuote} className="quote-form">
            <input
              type="text"
              value={quoteIdInput}
              onChange={(e) => setQuoteIdInput(e.target.value)}
              placeholder="CRM Quote ID (např. 117792000001234567)"
            />
            <button type="submit" className="btn-primary">
              Otevřít nabídku
            </button>
          </form>
        </section>

        {/* Admin Dashboard Card */}
        <section className="dashboard-card chat-link-card" onClick={() => navigate('/admin')}>
          <div className="card-content-row">
            <div>
              <h2>⚙️ Admin Dashboard</h2>
              <p>DataStore editor, experiment actions, system tools</p>
            </div>
          </div>
          <button className="btn-secondary full-width">
            Otevřít admin →
          </button>
        </section>

        {/* Chat Dashboard Card */}
        <section className="dashboard-card chat-link-card" onClick={() => navigate('/chats')}>
          <div className="card-content-row">
            <div>
              <h2>💬 Chat Dashboard</h2>
              <p>Správa konverzací se zákazníky</p>
            </div>
            {unreadCount > 0 && (
              <span className="unread-badge-large">{unreadCount}</span>
            )}
          </div>
          <button className="btn-secondary full-width">
            Otevřít chaty →
          </button>
        </section>
      </div>
    </div>
  );
}

export default HomePage;